import { useState } from "react";
import { createSelectorConfirm } from "../../utils/createSelectorConfirm";

// kendaraan, supir (berangkat / pulang), pemakai and tujuan selectors.
// The trailer selector(s) differ per editor, see the variant's useEditorTrailerDialogs.
const useEditorSelectorDialogs = ({
  headerData,
  setHeaderData
}) => {
  // dialog state
  const [showKendaraanSelector, setShowKendaraanSelector] = useState(false);
  const [showSupirSelector, setShowSupirSelector] = useState(false);
  const [showSupirPulangSelector, setShowSupirPulangSelector] = useState(false);
  const [showPemakaiSelector, setShowPemakaiSelector] = useState(false);
  const [showTujuanSelector, setShowTujuanSelector] = useState(false);

  // handle UI event section

  const handleOnClickSupir = () => {
    setShowSupirSelector(true);
  };

  const handleOnClickSupirPulang = () => {
    setShowSupirPulangSelector(true);
  };

  const handleOnClickKendaraan = () => {
    setShowKendaraanSelector(true);
  };

  const handleOnClickPemakai = () => {
    setShowPemakaiSelector(true);
  };

  const handleOnClickTujuan = () => {
    setShowTujuanSelector(true);
  };

  const handleOnConfirmSupir = createSelectorConfirm({
    headerData,
    setHeaderData,
    dataField: "data_supir",
    idField: "supir_id",
    setShow: setShowSupirSelector,
  });

  const handleOnConfirmSupirPulang = createSelectorConfirm({
    headerData,
    setHeaderData,
    dataField: "data_supir_pulang",
    idField: "supir_pulang_id",
    setShow: setShowSupirPulangSelector,
  });

  const handleOnConfirmKendaraan = createSelectorConfirm({
    headerData,
    setHeaderData,
    dataField: "data_kendaraan",
    idField: "kendaraan_id",
    setShow: setShowKendaraanSelector,
  });

  const handleOnConfirmPemakai = createSelectorConfirm({
    headerData,
    setHeaderData,
    dataField: "data_pemakai",
    idField: "pemakai_id",
    setShow: setShowPemakaiSelector,
  });

  const handleOnConfirmTujuan = createSelectorConfirm({
    headerData,
    setHeaderData,
    dataField: "data_tujuan",
    idField: "tujuan_id",
    setShow: setShowTujuanSelector,
  });

  return {
    showKendaraanSelector,
    setShowKendaraanSelector,
    showSupirSelector,
    setShowSupirSelector,
    showSupirPulangSelector,
    setShowSupirPulangSelector,
    showPemakaiSelector,
    setShowPemakaiSelector,
    showTujuanSelector,
    setShowTujuanSelector,
    handleOnClickSupir,
    handleOnClickSupirPulang,
    handleOnClickKendaraan,
    handleOnClickPemakai,
    handleOnClickTujuan,
    handleOnConfirmSupir,
    handleOnConfirmSupirPulang,
    handleOnConfirmKendaraan,
    handleOnConfirmPemakai,
    handleOnConfirmTujuan
  };
};

export default useEditorSelectorDialogs;
